export default "__VITE_PUBLIC_ASSET__b49c6d00__"